import React from "react";
import "../css/callModal.css";

// components/CallModal.jsx
export default function CallModal({ callerName, type, onAccept, onReject, canAccept }) {
  return (
    <div className="call-modal">
      <div className="call-box">
        <h3>{type === "video" ? "Video Call" : "Voice Call"} Incoming</h3>
        <p>{callerName} is calling you</p>
        <div className="call-actions">
          <button className="accept-btn" onClick={onAccept} disabled={!canAccept}>
            {canAccept ? "Accept" : "Preparing…"}
          </button>
          <button className="reject-btn" onClick={onReject}>Reject</button>
        </div>
      </div>
    </div>
  );
}